/**
 * Live subscription to the project Block Examples Library
 * (projects/{pid}/blockLibrary) — pattern: useBlockSubtypes.
 */
import { useEffect, useMemo, useState } from 'react';
import { BlockLibraryService } from '@modules/firebase-core/services/BlockLibraryService';
import type { BlockLibraryExampleDoc } from '@modules/shared-types';

export interface UseBlockLibraryExamplesResult {
  examples: BlockLibraryExampleDoc[];
  loading: boolean;
  error: Error | null;
}

export function useBlockLibraryExamples(projectId: string): UseBlockLibraryExamplesResult {
  const service = useMemo(() => new BlockLibraryService(projectId), [projectId]);
  const [examples, setExamples] = useState<BlockLibraryExampleDoc[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setExamples([]);
    setLoading(true);
    setError(null);
    return service.subscribe((next) => {
      setExamples(next);
      setLoading(false);
    }, (nextError) => {
      setError(nextError);
      setLoading(false);
    });
  }, [service]);

  return { examples, loading, error };
}
